// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

// Documentation site URL (opens in new tab). Set REACT_APP_DOCS_URL in production. When running on localhost (main app), default to docs on 3001 so the new tab opens the docs app, not the main app.
function getDocsUrl() {
  if (process.env.REACT_APP_DOCS_URL) return process.env.REACT_APP_DOCS_URL;
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost' && window.location.port === '3000') {
    return 'http://localhost:3001';
  }
  return 'https://docs.signtada.com';
}
const DOCS_URL = getDocsUrl();

/** Build full URL for branding logo (handles relative paths and uploads/ prefix). */
export function getBrandingLogoUrl(logoUrl, baseUrl = API_BASE_URL) {
  if (!logoUrl || typeof logoUrl !== 'string') return '';
  if (logoUrl.startsWith('http://') || logoUrl.startsWith('https://')) return logoUrl;
  if (logoUrl.startsWith('uploads/')) return `${baseUrl}/files/${logoUrl}`;
  return `${baseUrl}/files/uploads/${logoUrl}`;
}

export { DOCS_URL };
export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  DASHBOARD: `${API_BASE_URL}/dashboard`,
  BRANDING: `${API_BASE_URL}/branding`,
  BRANDING_PUBLIC: `${API_BASE_URL}/branding/public`,
  BRANDING_UPDATE: `${API_BASE_URL}/branding/update`,
};

export default API_BASE_URL;
